module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/group-ordering-03-e50ecc54d066e07d7581ce34d42b3a08.jpg";